export default [
    {
        path: '/drivers',
        name: 'indexDrivers',
        meta: { title: 'indexDriversAdmin' },
        component: () => import('@/pages/drivers'),
    },
    {
        path: "/drivers/schedule/:id",
        name: "driversSchedule",
        meta: { title: 'driversSchedule' },
        component: () => import('@/pages/drivers/schedule'),
    },
]